import { createRouter, createWebHistory } from 'vue-router';
import { RoleGuard } from '@agyletime/vue-3-common/src/routes/guard';
import { SessionGuard } from '@agyletime/vue-3-common/src/routes/guard';
import { PageTitleSetter } from '@agyletime/vue-3-common/src/routes/guard';
import { FeatureFlowGuard } from '@agyletime/vue-3-common/src/routes/guard';
import { EventDashboard } from '@/components';

export const router = createRouter({
    // In dev we want to have the base (which has no CDN url) as vue-apps/vue_3_base/ or so and in prod
    // we want to avoid having https://website.com/https://cdn.website.com/vue-apps/vue_3_base/ as the
    // main portion is handled elsewhere. The `vue_3_base` portion is set using VITE_HISTORY_BASE_URL.
    // TODO: Propagate this change to other MFEs
    history: createWebHistory(import.meta.env.VITE_HISTORY_BASE_URL),
    routes: [
        {
            path: '/',
            name: 'SystemEvents',
            component: EventDashboard,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            beforeEnter: async () => {
                const can = await RoleGuard(['view_system_events_dashboard'], true);
                return FeatureFlowGuard('event-logs-links-and-route') && can;
            },
            meta: { title: 'Event Dashboard' }
        }
    ]
});

router.beforeEach(SessionGuard);
router.beforeEach(PageTitleSetter);
